import { AutocompleteRenderGetTagProps, Chip, Stack, Tooltip } from '@mui/material'
import { LockedPadlockOMIcon } from '@omnea-app/icons'
import { AssigneeAvatar, AssigneeAvatarOption } from '../../avatar/AssigneeAvatar'

interface AssigneeAutocompleteTagChipProps {
  option: AssigneeAvatarOption
  label: string
  getTagProps: AutocompleteRenderGetTagProps
  index: number
  isValid: boolean
  isLocked?: boolean
  lockedTooltip?: string
}

export const AssigneeAutocompleteTagChip = ({
  option,
  label,
  getTagProps,
  index,
  isValid,
  isLocked = false,
  lockedTooltip,
}: AssigneeAutocompleteTagChipProps) => {
  const { onDelete, ...tagProps } = getTagProps({ index })

  const chip = (
    <Chip
      avatar={<AssigneeAvatar option={option} sx={{ marginLeft: 1 }} />}
      label={
        isLocked ? (
          <Stack direction="row" alignItems="center" gap={0.5} component="span">
            {label}
            <Stack component="span" aria-label={lockedTooltip}>
              <LockedPadlockOMIcon size={12} />
            </Stack>
          </Stack>
        ) : (
          label
        )
      }
      size="small"
      {...tagProps}
      onDelete={isLocked ? undefined : onDelete}
      key={index}
      data-testid={`assignee-chip-${option.value}`}
      color={!isValid ? 'error' : 'neutral'}
      variant="selection"
    />
  )

  return isLocked ? (
    <Tooltip describeChild title={lockedTooltip}>
      {chip}
    </Tooltip>
  ) : (
    chip
  )
}
